import template from './create_cycle.html';
import * as Utils from '../../lib/savanna_utils.js';

class CreateCycleViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
		this.performance_cycle_id = ko.observable();
		this.date = ko.observable(moment().format('YYYY-MM-DD hh:mm'));
		this.departments = ko.observableArray();
		this.selected_department = ko.observable();
		this.companies = ko.observableArray();
		this.selected_company = ko.observable();
		this.title = ko.observable();
		this.cycle_name = ko.observable();
		this.from_date = ko.observable();
		this.to_date = ko.observable();
		this.company_id = ko.observable();
		this.selected_cycle = ko.observable();
		this.performance_cycles_steps = ko.observableArray();
		this.add_predefined = ko.observable(false);
		this.add_default = ko.observable(true);
		this.add_peer_group = ko.observable(false);
		this.peer_group = ko.observableArray();
		this.selected_group = ko.observable();

		// Add peer group employee management observables
		this.available_employees = ko.observableArray([]);
		this.peer_group_employees = ko.observableArray([]);
		this.selected_available_employees = ko.observableArray([]);
		this.selected_group_employees = ko.observableArray([]);

		// Track original peer group data for edit mode
		this.original_peer_group_id = ko.observable();
		this.original_peer_members = ko.observableArray([]);

		// Computed observables for display names
		this.available_employee_names = ko.computed(() => {
			return this.available_employees().map(emp => `${emp.firstname} ${emp.surname}`);
		});

		this.current_group_employees = ko.computed(() => {
			return this.peer_group_employees().map(emp => `${emp.firstname} ${emp.surname}`);
		});

		// Subscribe to selected peer group changes
		this.selected_group.subscribe(async (val) => {
			if (this.selected_group()) {
				await this.load_peer_group_employees();
			} else {
				// If no peer group selected, load department employees for individual selection
				await this.load_department_employees();
			}
		});

		// Subscribe to department changes
		this.selected_department.subscribe(async (val) => {
			if (this.add_peer_group() && !this.selected_group()) {
				// Reload department employees when department changes and no peer group is selected
				await this.load_department_employees();
			}
		});

		this.add_peer_group.subscribe(async (val) => {
			if (val) {
				// If no peer group is selected, load department employees
				if (!this.selected_group()) {
					await this.load_department_employees();
				} else {
					await this.load_peer_group_employees();
				}
			} else {
				// Clear employee lists when peer group is disabled
				this.available_employees([]);
				this.peer_group_employees([]);
				this.selected_available_employees([]);
				this.selected_group_employees([]);
				this.selected_group(null);
			}
		});

		this.view_date = ko.computed(() => {
			return 'View/Print Date:  ' + this.date();
		});

		this.company_changed = ko.computed(() => {
			if (this.selected_company() === this.company_id())
				return false;
			else
				return true;
		});

		this.selected_company.subscribe((val) => {
			if (this.selected_company() && this.company_changed())
				this.dialog.updateData();
		});

		this.selected_cycle.subscribe((val) => {
			if (this.selected_cycle())
				this.add_default(false);
		});

		this.add_default.subscribe((val) => {
			if (val ===  true)
				this.selected_cycle(null);
		});
	};


	select_company(company_id, data, event) {
	    event.preventDefault();
	    event.stopPropagation();
	    this.selected_company(company_id);
	
	    // Close the dropdown by triggering a click outside
	    setTimeout(() => {
	        const dropdown = event.target.closest('.ps-dropdown');
	        if (dropdown) {
	            const input = dropdown.querySelector('input');
	            if (input) {
	                input.setAttribute('aria-expanded', 'false');
	                input.blur();
	            }
	            dropdown.classList.remove('show');
	        }
	        // Trigger a click on the document to close any open dropdowns
	        document.body.click();
	    }, 0);
	}
	
	select_department(department_id, data, event) {
	    event.preventDefault();
	    event.stopPropagation();
	    // Allow null to be set for "All Departments"
	    this.selected_department(department_id === null ? null : department_id);
	
	    // Close the dropdown by triggering a click outside
	    setTimeout(() => {
	        const dropdown = event.target.closest('.ps-dropdown');
	        if (dropdown) {
	            const input = dropdown.querySelector('input');
	            if (input) {
	                input.setAttribute('aria-expanded', 'false');
	                input.blur();
	            }
	            dropdown.classList.remove('show');
	        }
	        // Trigger a click on the document to close any open dropdowns
	        document.body.click();
	    }, 0);
	}

	// Helper method to get employee object from display name
	get_employee_from_display_name(displayName) {
		return this.available_employees().find(emp => 
			`${emp.firstname} ${emp.surname}` === displayName);
	}

	// Helper method to get employee object from peer group employees
	get_peer_employee_from_display_name(displayName) {
		return this.peer_group_employees().find(emp => 
			`${emp.firstname} ${emp.surname}` === displayName.trim());
	}

	// Add peers to the group
	 btn_add_peers_click() {
        if (this.selected_available_employees().length === 0) return;
        
        // **UPDATED**: Allow adding individual peers even when peer group is selected
        // The backend will handle assigning correct peer_group_id values
        if (this.selected_group()) {
            // Show info about mixed scenario
            Grape.alerts.alert({ 
                type: 'Warning', 
                message: 'Adding individual peer members alongside the selected peer group. Members who are not part of the peer group will be added as individual peers.' 
            });
        }
        
        let selected_employees = this.selected_available_employees().map(name => {
            return this.get_employee_from_display_name(name);
        }).filter(Boolean); // Filter out any undefined values
        
        // Add to peer group
        this.peer_group_employees.push(...selected_employees);
        
        // Remove from available employees
        this.available_employees(this.available_employees().filter(emp => 
            !selected_employees.some(selected => selected.employee_id === emp.employee_id)
        ));
        
        // Clear selection
        this.selected_available_employees([]);
    }

    btn_remove_peers_click() {
        if (this.selected_group_employees().length === 0) return;
        
        // **UPDATED**: Allow removing individual peers even when peer group is selected
        // Users should be able to manage the mixed list
        
        let selected_employees = this.selected_group_employees().map(name => {
            return this.get_peer_employee_from_display_name(name);
        }).filter(Boolean); // Filter out any undefined values
        
        // Add back to available employees
        this.available_employees.push(...selected_employees);
        
        // Remove from peer group
        this.peer_group_employees(this.peer_group_employees().filter(emp => 
            !selected_employees.some(selected => selected.employee_id === emp.employee_id)
        ));
        
        // Clear selection
        this.selected_group_employees([]);
    }

	async load_department_employees() {
		try {
			let filter = [{}];
			
			// If a specific department is selected, filter by it
			if (this.selected_department()) {
				filter = [{
					field: 'department_id',
					operand: '=',
					value: this.selected_department()
				}];
			}
			// If no department selected but company is selected, filter by company
			else if (this.selected_company()) {
				filter = [{
					field: 'company_id',
					operand: '=',
					value: this.selected_company()
				}];
			}

			// Load all employees from the department/company
			let options = {
				table: 'v_active_employees_department',
				schema: 'savanna',
				limit: 1000000,
				fields: ['id_number', 'firstname', 'surname', 'employee_id', 'email', 'date_started', 'department_id'],
				filter: filter,
				order: [
                	{ field: 'firstname', direction: 'asc' },
                	{ field: 'surname', direction: 'asc' }
            	]
			};
			
			let res = await Grape.fetches.getJSON('/api/record', options);
			if (res.status != 'ERROR' && res.records && Array.isArray(res.records)) {
				// Get current employee ID to exclude from available employees
				const currentEmployeeId = Utils.current_user_id();
				
				// Filter out the current employee and any already selected peer members
				let availableEmployees = res.records.filter(emp => {
					// Exclude current employee
					if (currentEmployeeId && emp.employee_id === currentEmployeeId) {
						return false;
					}
					// Exclude employees already in peer group
					return !this.peer_group_employees().some(peerEmp => 
						peerEmp.employee_id === emp.employee_id
					);
				});

				availableEmployees.sort((a, b) => {
                	const nameA = `${a.firstname} ${a.surname}`.toLowerCase();
                	const nameB = `${b.firstname} ${b.surname}`.toLowerCase();
                	return nameA.localeCompare(nameB);
            	});
				
				// Set available employees
				this.available_employees(availableEmployees || []);
				
				// Clear selections
				this.selected_available_employees([]);
				this.selected_group_employees([]);
			}
			else
			{
				// Handle case where no records are returned
				this.available_employees([]);
				this.selected_available_employees([]);
				this.selected_group_employees([]);
				
				if (res.status === 'ERROR') {
					Grape.alerts.alert({ type: 'error', message: 'An error occurred while loading employees.' });
				}
			}
		}
		catch (error) {
			console.error(error);
			// Reset arrays to prevent undefined errors
			this.available_employees([]);
			this.selected_available_employees([]);
			this.selected_group_employees([]);
			
			Grape.alerts.alert({ type: 'error', message: 'An error occurred while loading employees: ' + error.message });
		}
	}
	
	// Load peer group employees and available employees
	async load_peer_group_employees() {
        if (!this.selected_group()) return;

        try {
            let selected_peer_group = this.peer_group().find(group => group.peer_group_id === this.selected_group());
            if (!selected_peer_group) return;

            // Load existing peer group members from the v_peer_group view
            let existing_members_res = await Grape.fetches.getJSON('/api/record', {
                table: 'v_peer_group',
                schema: 'perfm_manage',
                fields: ['employee_id', 'full_name'],
                filter: [{
                    field: 'peer_group_id',
                    operand: '=',
                    value: this.selected_group()
                }]
            });

            let existing_members = [];
            if (existing_members_res.status != 'ERROR' && existing_members_res.records && Array.isArray(existing_members_res.records)) {
                // Remove duplicates from existing members based on employee_id
                const uniqueMembers = new Map();
                existing_members_res.records.forEach(member => {
                    if (!uniqueMembers.has(member.employee_id)) {
                        // Parse the full_name to get firstname and surname
                        const nameParts = member.full_name ? member.full_name.split(' ') : ['', ''];
                        const firstname = nameParts[0] || '';
                        const surname = nameParts.slice(1).join(' ') || '';
                        
                        uniqueMembers.set(member.employee_id, {
                            employee_id: member.employee_id,
                            firstname: firstname,
                            surname: surname,
                            peer_member_id: member.peer_member_id
                        });
                    }
                });
                existing_members = Array.from(uniqueMembers.values());
            }

			existing_members.sort((a, b) => {
                	const nameA = `${a.firstname} ${a.surname}`.toLowerCase();
                	const nameB = `${b.firstname} ${b.surname}`.toLowerCase();
                	return nameA.localeCompare(nameB);
            	});
            
            // Set current peer group members
            this.peer_group_employees(existing_members || []);

            // **CHANGED**: Also load available employees for mixed scenarios
            // This allows users to add individual members alongside peer group members
            await this.load_department_employees();
            
        }
        catch (error)
        {
            console.error(error);
            // Reset arrays to prevent undefined errors
            this.available_employees([]);
            this.peer_group_employees([]);
            this.selected_available_employees([]);
            this.selected_group_employees([]);
            
            Grape.alerts.alert({ type: 'error', message: 'An error occurred while loading peer group employees: ' + error.message });
        }
    }

	// Load existing peer data for edit mode
	async load_existing_peer_data(cycleId) {
		try {
			// Load existing peer members for this cycle
			let peer_members_res = await Grape.fetches.getJSON('/api/record', {
				table: 'v_peer_member_cycle', 
				schema: 'perfm_manage',
				fields: ['employee_id', 'firstname', 'surname', 'peer_group_id', 'peer_member_id'],
				filter: [{
					field: 'performance_cycle_id',
					operand: '=',
					value: cycleId
				}]
			});

			if (peer_members_res.status !== 'ERROR' && peer_members_res.records && Array.isArray(peer_members_res.records)) {
				// Check if there's a peer group associated
				let peer_group_id = null;
				let peer_members = [];

				peer_members_res.records.forEach(member => {
					if (member.peer_group_id) {
						peer_group_id = member.peer_group_id;
					}
					peer_members.push({
						employee_id: member.employee_id,
						firstname: member.firstname,
						surname: member.surname,
						peer_member_id: member.peer_member_id
					});
				});

				// If there's a peer group, set it
				if (peer_group_id) {
					this.selected_group(peer_group_id);
					this.add_peer_group(true);
				} else if (peer_members.length > 0) {
					// Individual peer members without peer group
					this.add_peer_group(true);
					this.peer_group_employees(peer_members);
					// Load available employees
					await this.load_department_employees();
				}

				// Store original data for comparison
				this.original_peer_group_id(peer_group_id);
				this.original_peer_members(peer_members);
			}
		} catch (error) {
			console.error('Error loading existing peer data:', error);
		}
	}

	close()
	{
		this.dialog.close();
	}

	validate_peer_members() {
        // Remove duplicate peer members based on employee_id
        const uniquePeerMembers = [];
        const seenEmployeeIds = new Set();
        
        this.peer_group_employees().forEach(emp => {
            if (!seenEmployeeIds.has(emp.employee_id)) {
                seenEmployeeIds.add(emp.employee_id);
                uniquePeerMembers.push(emp);
            }
        });
        
        // Update the array if duplicates were found
        if (uniquePeerMembers.length !== this.peer_group_employees().length) {
            this.peer_group_employees(uniquePeerMembers);
            console.warn('Duplicate peer members were removed before saving');
        }

        // **NEW**: If a peer group is selected, validate that all members belong to that group
        if (this.selected_group()) {
            return this.validate_peer_group_membership(uniquePeerMembers);
        }
        
        return uniquePeerMembers;
    }

	async validate_peer_group_membership(peerMembers) {
        if (!this.selected_group() || peerMembers.length === 0) {
            return peerMembers;
        }

        try {
            // Get all valid members of the selected peer group
            let peer_group_members_res = await Grape.fetches.getJSON('/api/record', {
                table: 'v_peer_group',
                schema: 'perfm_manage',
                fields: ['employee_id', 'full_name'],
                filter: [{
                    field: 'peer_group_id',
                    operand: '=',
                    value: this.selected_group()
                }]
            });

            if (peer_group_members_res.status === 'ERROR') {
                console.error('Error validating peer group membership');
                return peerMembers;
            }

            // Create a set of valid employee IDs for the selected peer group
            const validEmployeeIds = new Set(
                peer_group_members_res.records.map(member => member.employee_id)
            );

            // Count members who are not part of the selected peer group
            const nonGroupMembers = peerMembers.filter(member => 
                !validEmployeeIds.has(member.employee_id)
            );

            // Show info message if there are members who will be added as individuals
            if (nonGroupMembers.length > 0) {
                const nonGroupNames = nonGroupMembers.map(m => `${m.firstname} ${m.surname}`).join(', ');
                Grape.alerts.alert({ 
                    type: 'warning', 
                    message: `${nonGroupMembers.length} employee(s) (${nonGroupNames}) will be added as individual peer members since they are not part of the selected peer group.` 
                });
            }

            // Return all members - let the backend handle the peer_group_id assignment
            return peerMembers;

        } catch (error) {
            console.error('Error validating peer group membership:', error);
            return peerMembers;
        }
    }
	
	 async btn_save_cycle() {
        let predefined;
        if ((this.selected_cycle() || this.add_default()) && this.add_predefined())
            predefined = true;
        else
            predefined = false;


		if (!this.from_date() || !this.to_date()) {
            Grape.alerts.alert({ type: 'warning', message: "Performance Cycle's needs a start and end date!" });
            return;
        }
		if ( this.to_date() < this.from_date()) {
            Grape.alerts.alert({ type: 'warning', message: "Performance Cycle's untill date can not be before the from date " });
            return;
        }

        if (!this.cycle_name()) {
            Grape.alerts.alert({ type: 'warning', message: "Performance Cycle's name cannot be empty!" });
            return;
        }
        else {
            try {
                // Build the base request data
                let requestData = {
                    cycle_id: this.performance_cycle_id(),
                    cycle_name: this.cycle_name(),
                    department_id: this.selected_department(),
                    company_id: this.selected_company(),
                    from_date: this.from_date(),
                    to_date: this.to_date(),
                    predefined: predefined,
                    template: this.selected_cycle(),
                    action: 'edit'
                };

                // Add peer group data if enabled
                if (this.add_peer_group()) {
                    // **ENHANCED**: Validate and clean peer members with peer group validation
                    const validatedPeerMembers = await this.validate_peer_members();
                    
                    // **NEW**: Add the selected peer group ID to the request
                    if (this.selected_group()) {
                        requestData.selected_peer_group_id = this.selected_group();
                    }
                    
                    // Map peer members with their peer group information
                    requestData.peer_members = validatedPeerMembers.map(emp => ({
                        employee_id: emp.employee_id,
                        peer_member_id: emp.peer_member_id || null,
                        // Include peer_group_id if a peer group is selected
                        peer_group_id: this.selected_group() || null
                    }));

                } else {
                    // Explicitly set to empty array when peer group is disabled
                    requestData.peer_members = [];
                    requestData.selected_peer_group_id = null;
                }

                console.log('Request data:', requestData);

                let res = await Grape.fetches.postJSON('/performance_management/cycle/edit', requestData);

                if (res.status != 'ERROR') {
                    Grape.alerts.alert({ type: 'success', message: 'Performance cycle saved successfully!' });
                    this.dialog.close();
                }
                else {
                    Grape.alerts.alert({ type: 'error', message: res.message || 'An error occurred while saving the performance cycle' });
                }
            } catch (error) {
                console.error(error);
                Grape.alerts.alert({ type: 'error', message: 'An error occurred: ' + error.message });
            }
        }
    }
};

class CreateCyclePage
{
	constructor (bindings)
	{
		this.viewModel = new CreateCycleViewModel(this);
		this.bindings = bindings;
	};

	async init()
	{
		Utils.refresh_data_visible_roles();

		try {
			let res = await Grape.fetches.getJSON('/api/record', {
				table: 'company',
				schema: 'public'
			});
			if (res.status != 'ERROR')
			{
				this.viewModel.companies(res.records);
			}
		} catch(error)
		{
			console.error(error);
			Grape.alerts.alert({type: 'error', title: 'error', message: 'An error occurred while loading companies'});
		}

		try {
			let res = await Grape.fetches.getJSON('/api/record', {
				table: 'v_peer_group',
				schema: 'perfm_manage',
				filter: [{}]
			});

			if (res.status !== 'ERROR') {
				// Remove duplicate peer_group_name entries
				let unique_groups = [];
				let names_seen = new Set();

				for (const group of res.records) {
					if (!names_seen.has(group.peer_group_name)) {
						names_seen.add(group.peer_group_name);
						unique_groups.push(group);
					}
				}

				this.viewModel.peer_group(unique_groups);
			}
		} catch (error) {
			console.error(error);
			Grape.alerts.alert({
				type: 'error',
				title: 'Error',
				message: 'An error occurred when loading the Peer Groups'
			});
		}

		if (this.bindings.data)
			if (this.bindings.edit === true)
			{
				this.viewModel.company_id(this.bindings.data.company_id);
				this.viewModel.title('Edit Performance Cycle');
				this.viewModel.performance_cycle_id(this.bindings.data.performance_cycle_id);
				this.viewModel.cycle_name(this.bindings.data.cycle_name);
				this.viewModel.to_date(this.bindings.data.to_date);
				this.viewModel.from_date(this.bindings.data.from_date);
				this.viewModel.selected_company(this.bindings.data.company_id);
				await this.updateData();
				this.viewModel.selected_department(this.bindings.data.department_id);
				
				// Load existing peer data
				await this.viewModel.load_existing_peer_data(this.bindings.data.performance_cycle_id);
			}
			else
				this.viewModel.title('Add Performance Cycle');
	}

	async updateData()
	{
		if (this.viewModel.selected_company())
		{
			try {
				let res = await Grape.fetches.getJSON('/api/record', {
					table: 'v_department_company',
					schema: 'savanna',
					filter: [{
						field: 'company_id',
						operand: '=',
						value: this.viewModel.selected_company()
					}]
				})
				if (res.status != 'ERROR')
				{
					res.records.unshift({ department: 'All Departments', department_id: null });
					this.viewModel.departments(res.records);
				}
			} catch (error) {
				console.error(error);
				Grape.alerts.alert({type: 'error', title: 'error', message: 'An error occurred while loading departments'});
			}
		}

		let options = {
			table: 'v_performance_cycles',
			schema: 'perfm_manage'
		}

		try {
			let res = await Grape.fetches.getJSON('/api/record', options)
			if (res.status != 'ERROR')
				this.viewModel.performance_cycles_steps(res.records);
			else 
				Grape.alerts.alert({type: 'error', message: 'An Error occurred while loading performance cycles for stages templates.'});

		} catch (error) {
			console.error(error);
		}
	}
};

export default {
	name: 'CreateCycle',
	dialog_class: CreateCyclePage,
	template: template,
	template_filename: 'translation/dialogs/create_cycle',
	provider: 'ps'
};